import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import adminKycService from '../api/adminKycService';
import vendorKycService from '../api/vendorKycService';

const KEYS = {
    all: ['kycs'],
    detail: (userId) => ['kyc', userId],
    vendor: ['vendor-kyc']
};

export const useKycs = () => {
    return useQuery({
        queryKey: KEYS.all,
        queryFn: () => adminKycService.getAll().then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

export const useKycDetails = (userId) => {
    return useQuery({
        queryKey: KEYS.detail(userId),
        queryFn: () => adminKycService.getDetails(userId).then((res) => res.data),
        enabled: !!userId,
        staleTime: 5 * 60 * 1000
    });
};

export const useVendorKyc = () => {
    return useQuery({
        queryKey: KEYS.vendor,
        queryFn: () => vendorKycService.getKyc().then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

export const useSubmitVendorKyc = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => vendorKycService.submitKyc(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.vendor });
            queryClient.invalidateQueries({ queryKey: ['user'] });
        }
    });
};

// General Status Update
export const useKycUpdateStatus = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, status }) => adminKycService.updateStatus(id, status),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: ['kyc'] });
        }
    });
};

export const useKycUpdateNinStatus = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ninStatus, message }) => adminKycService.updateNinStatus(id, ninStatus, message),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: ['kyc'] });
        }
    });
};
